import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bh_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const gbp = (n) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(n);

export const photoUrl = (path) => `${process.env.REACT_APP_BACKEND_URL}/api/review-photos/${path}`;

const RECENT_KEY = "hhcv_recently_viewed";
export const addRecentlyViewed = (slug) => {
  try {
    const a = JSON.parse(localStorage.getItem(RECENT_KEY) || "[]").filter((s) => s !== slug);
    a.unshift(slug);
    localStorage.setItem(RECENT_KEY, JSON.stringify(a.slice(0, 10)));
  } catch { /* ignore */ }
};
export const getRecentlyViewed = () => {
  try { return JSON.parse(localStorage.getItem(RECENT_KEY) || "[]"); } catch { return []; }
};

export default api;
